export const searchJobsPathByLocale = {
  en: '/en/jobs',
  es: '/es/empleos',
  pt: '/pt/empregos',
} as const;

export const searchJobsPaths = Object.values(searchJobsPathByLocale);

export const searchJobsPathsWithoutLang = Array.from(
  new Set(searchJobsPaths.map((path) => path.substring(3))),
);
